/**
 * <Icon name="back"/>
 * @file: Icon.js
 * @desc: 字体图标
 * @usage
 *
 * @providesModule IconX
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import {DeviceInfo} from 'qunar-react-native';
import { equalInner } from '../common/utils';

/**
 * icon name map
 * @type {Object}
 */
const ICON = {
    flight: '\ue314',
    down: '\ue7f4',
    hot: '\ue560',
    back: '\ue421',
    rightArrow: '\ue42e',
    close: '\ue5a3',
    // 返回箭头
    backLight: '\uf07d',
    backArrow: '\ue3dd',
    //向右箭头
    right: '\uf3c8',
    arrowDownward: '\uf3c7',
    arrowUpward: '\uf3c6',
    //人民币符号
    yen: '\uf244',
    info: '\uf0f6', // 可以去除了
    newInfo: '\ue3e0',
    //实心圆圈删除
    roundDelete: '\uf093',

    //联系人图标
    contact: '\ue52b',

    //勾选 对号
    check: '\uea15',
    check2: '\ue43d',
    //单程箭头
    oneway: '\ue9cd',
    //往返箭头
    roundTrip: '\ue9ce',
    // up: '\uf027',
    cycle: '\uf35d',
    //圆圈"1"、"2"、"3"
    voyageIcon1: '\uf421',
    voyageIcon2: '\uf423',
    voyageIcon3: '\uf425',
    goTextIcon: '\uf419',
    backTextIcon: '\uf41f',
    firstTextIcon: '\uf420',
    secondTextIcon: '\ue1c1',
    // 细叉叉
    unckeckLight: '\uf3f3',
    //定位icon
    destination:'\ue061',
    //共享航班箭头
    shareArrow:'\uf107',
    //圆形已勾选
    circleSelect: '\uf522',
    // 用户反馈
    feedBack: '\uf48e',
    //电话
    phone: '\uf3da',

    //圆圈叉子关闭按钮
    roundClose: '\uf3f4',
    floatClose: '\ue5a3',

    share: '\uf0dd',

    more: '\uf07e',
    rightMore: '\ue3b5',

    home: '\uf228',
    naviItemWallet: '\uf4d7',

    // 选中的圆勾
    selected:'\ue3b7',
    unselect:'\ue3b8',

    //填单页图标
    add: '\uf38d',

    //删除乘机人
    deleteCircle:'\uf436',

    uncheck: '\uf35d',

    //护照扫描
    passportscan: '\ue3df',

    // 邀请填写乘机人
    inviteToFillPassenger: '\uea29',
    //他人自填
    user: '\uf0eb',

    //编辑
    edit: '\uf04d',
    editNew: '\ue45a',

    //勾选的圈
    circle_checked: '\uf522',

    //历史乘机人
    history_passenger: '\uf3e3',

    //男
    male: '\ue0dd',

    //女
    female: '\ue0e0',

    //右箭头圈
    right_arrow:'\ue1f9',

    //时钟
    clock:'\ue158',

    //对勾
    checked: '\uf056',
    //同意对勾
    bigCheck: '\uf009',
    //向下
    // down: '\uf3cb',
    //向上
    up: '\uf3ca',
    // 向上粗
    upBold: '\uf3c6',
    // 向下粗
    // downBlod: '\uf3c7',

    //客服
    qchat: '\uf3de',
    // 新客服按钮
    chat: '\ue299',
    //最新客服按钮
    newchat:'\ue546',
    //圆点
    dot: '\uf3f9',

    // 皇冠
    associator: '\uf3e6',
    // 行李
    luggage: '\ue3f0',
    // 金额
    money: '\ue3f1',
    //实心三角向上、下箭头
    triDown: '\ue3f7',
    triUp: '\ue3f6',

    //火车站icon
    train:'\uf275',//&#xf275;
    //飞机icon
    plane:'\uf4e3',//&#xf4e3;
    //船
    ship:'\uf38f',
    //汽车
    bus:'\uf1eb',
    direct: '\uf553',
    checkIcon: '\uf472',
    newAdd: '\ue6ca',
    circleAdd: '\uf1a3',
    normalAdd: '\uf1c5',
    search: '\uf50c',
    exclamation: '\ue590',
    newExclamation: '\ue0ca',
    moreCircle: '\ue3af',//更多
    qTurnUp:'\ue3f6',
    qTurnDown:'\ue3f7',
    qSuagr: '\ue109',
    loupe: '\ue41f',
    goTop: '\ue441'
};

const defaultProps = {
    name: 'back',
    color: null,
    size: null,
    style: null
};

const propTypes = {
    /**
     * 图标名字，如果没有请加入ICON map 中
     * @type {String}
     */
    name: PropTypes.string,
    /**
     * 图标颜色，传入color 默认是 #2aa9b9
     * @type {String}
     */
    color: PropTypes.string,
    /*
     * 图标大小，出入数字，默认是16
     * @type {Number}
     */
    size: PropTypes.number,
    /**
     * 图标样式，样式的优先级为 [color, size] > style > 默认
     * @type {Object}
     */
    style: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    // press function
    onPress: PropTypes.func
}

class Icon extends Component {

    shouldComponentUpdate(nextProps) {
        return !equalInner(this.props, nextProps);
    }

    render() {
        let Container = this.props.onPress ? TouchableOpacity : Text;
        return (
            <Container onPress={this.props.onPress} style={[this.props.style]}>
                <Text style={this.getStyle()}>
                    {this.getIconText()}
                </Text>
            </Container>
        );
    }

    getIconText() {
        return ICON[this.props.name] || this.props.name;
    }

    getStyle() {
        let props = this.props;

        return [
            styles.font,
            props.color ? {color: props.color} : null,
            props.size ? [
                {fontSize: props.size},
                !hysdk.sniff.qunar && props.size < 10 ? {display: 'flex', transform:([{scaleX: props.size / 10}, {scaleY: props.size / 10}])}:{}
            ] : null
        ]
    }
}

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

const styles = StyleSheet.create({
    font: {
        fontFamily: 'low_price_rn',
        color: '#00bcd4',
        fontSize: 16,
        fontWeight: 'bold',
        backgroundColor: 'rgba(0,0,0,0)'
    }
})

export default Icon;
